import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { WelcomeComponent } from "../../components/welcome/welcome.component";
import { AuthkitService } from "../../services/authKit.service";

@Component({
  selector: "app-home",
  standalone: true,
  imports: [
    WelcomeComponent
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss"
})
export class HomeComponent implements OnInit {


  constructor(
    private _route: ActivatedRoute,
    private _authKitService: AuthkitService,
  ) { }

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((params) => {
      const code = params.get("code")

      if (code)
        this._handleAuthentication(code)
    });
  }

  private _handleAuthentication(code: string) {
    this._authKitService.authenticateByCode(code)
  }
}